import { FC } from 'react';
import './ChatMessageVote.scss';
import { ReactComponent as IconThumbUp } from "../../../assets/icons/thumb-up-solid.svg";
import { useChats } from '../../../providers/Chats/ChatsProvider';

interface ChatMessageVoteProps {
  messageId: number;
  vote?: boolean | null;
  voted?: boolean;
}

const ChatMessageVote: FC<ChatMessageVoteProps> = ({ messageId, vote, voted }) => {
  const { handleVote, isLoadingVote } = useChats();

  return (
    <div className="ChatMessageVote" data-testid="ChatMessageVote">
      <p className="text-sm mb-1">Esta resposta foi útil?</p>
      <div className="d-flex align-items-center gap-1">
        <button
          className={`btn btn-transparent ${voted && vote ? 'active' : ''}`}
          disabled={voted || isLoadingVote}
          onClick={() => { handleVote(messageId, true) }}
          title='Marcar como útil'
        >
          {isLoadingVote ? (
            <div className="spinner-border spinner-border-sm" aria-hidden="true"></div>
          ) : (
            <IconThumbUp width={24} fill={`${voted && vote ? '#2c2a4e' : '#fff'}`} />
          )}
        </button>
        <button
          className={`btn btn-transparent ${voted && !vote ? 'active' : ''}`}
          disabled={voted || isLoadingVote}
          onClick={() => { handleVote(messageId, false) }}
          title='Marcar como não útil'
        >
          {isLoadingVote ? (
            <div className="spinner-border spinner-border-sm" aria-hidden="true"></div>
          ) : (
            <IconThumbUp width={24} className={`thumb-down`} fill={`${voted && !vote ? '#2c2a4e' : '#fff'}`} />
          )}
        </button>
      </div>
    </div>
  );
}

export default ChatMessageVote;
